import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  bulkDeactivateUsers,
  bulkMoveUsers,
  fetchUsersV3,
  fetchUsersV3Stats,
  UserSelection,
  UsersV3QueryParams,
} from "../../services/UsersV3Service";
import { fetchAccessibleOrganizations } from "../../services/OrganizationsV3Service";

// Error envelopes are shaped { "msg": "..." }; surface that message to the UI.
const toErrorMessage = (error: unknown): string => {
  const err = error as { response?: { data?: { msg?: string } }; message?: string };
  return err.response?.data?.msg || err.message || "An unexpected error occurred";
};

export const fetchUsersV3Async = createAsyncThunk(
  "usersV3/fetchList",
  async (params: UsersV3QueryParams, { rejectWithValue }) => {
    try {
      return await fetchUsersV3(params);
    } catch (error: unknown) {
      return rejectWithValue(toErrorMessage(error));
    }
  }
);

export const fetchUsersV3StatsAsync = createAsyncThunk(
  "usersV3/fetchStats",
  async (_: void, { rejectWithValue }) => {
    try {
      return await fetchUsersV3Stats();
    } catch (error: unknown) {
      return rejectWithValue(toErrorMessage(error));
    }
  }
);

// Options for the Organization filter and the move modal; loaded once per page
// visit and searched client-side.
export const fetchAccessibleOrganizationsAsync = createAsyncThunk(
  "usersV3/fetchAccessibleOrganizations",
  async (_: void, { rejectWithValue }) => {
    try {
      return await fetchAccessibleOrganizations();
    } catch (error: unknown) {
      return rejectWithValue(toErrorMessage(error));
    }
  }
);

export const bulkMoveUsersAsync = createAsyncThunk(
  "usersV3/bulkMove",
  async (
    { selection, destinationOrganizationId }: { selection: UserSelection; destinationOrganizationId: number },
    { rejectWithValue }
  ) => {
    try {
      return await bulkMoveUsers(selection, destinationOrganizationId);
    } catch (error: unknown) {
      return rejectWithValue(toErrorMessage(error));
    }
  }
);

export const bulkDeactivateUsersAsync = createAsyncThunk(
  "usersV3/bulkDeactivate",
  async (selection: UserSelection, { rejectWithValue }) => {
    try {
      return await bulkDeactivateUsers(selection);
    } catch (error: unknown) {
      return rejectWithValue(toErrorMessage(error));
    }
  }
);
